<h1 mat-dialog-title>
    {{'COOKIE_POLICY_DIALOG.TITLE'|translate}}
</h1>
<div mat-dialog-content>
    <div [innerHtml]="'COOKIE_POLICY_DIALOG.BODY'|translate"></div>
    <div [innerHtml]="'COOKIE_POLICY_DIALOG.CONCLUSION'|translate"></div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close cdkFocusInitial>{{'COOKIE_POLICY_DIALOG.CLOSE_BUTTON_LABEL' | translate}}</button>
</div>